import { NotificationData, notifications } from '@mantine/notifications';
import classes from './toasts.module.css';
import { ToastIcon } from './ToastIcon';

const commonNotificationOptions: Partial<NotificationData> = {
  title: null,
  position: 'bottom-left',
  classNames: classes,
  withCloseButton: false,
};

export function showError(message: string) {
  notifications.show({
    ...commonNotificationOptions,
    message: message,
    icon: <ToastIcon variant="error" />,
    autoClose: 4000,
  });
}

export function showSuccess(message: string) {
  notifications.show({
    ...commonNotificationOptions,
    message: message,
    icon: <ToastIcon variant="success" />,
    autoClose: 2000,
  });
}
